export class CookieSetter {
  static acceptsCookies = false;

  static acceptedGroups = [];

  static setCookieBuffer = [];

  static setGroupCookieBuffer = {};

  static revokedGroupBuffer = {};

  static whenAllowed(callback) {
    this.setCookieBuffer.push(callback);
    this.processBuffer();
  }

  static whenGroupAllowed(group, callback) {
    if (!this.setGroupCookieBuffer[group]) {
      this.setGroupCookieBuffer[group] = [];
    }
    this.setGroupCookieBuffer[group].push(callback);
    this.processBuffer();
  }

  static whenGroupRevoked(group, callback) {
    if (!this.revokedGroupBuffer[group]) {
      this.revokedGroupBuffer[group] = [];
    }
    this.revokedGroupBuffer[group].push(callback);
    this.processRevokedBuffer(group);
  }

  static acceptCookies() {
    this.acceptsCookies = true;
    this.processBuffer();
  }

  static acceptGroupCookies(group) {
    this.acceptedGroups.push(group);
    this.processBuffer();
  }

  static denyGroupCookies(group) {
    const groupIndex = this.acceptedGroups.indexOf(group);
    if (groupIndex !== -1) {
      this.acceptedGroups.splice(groupIndex, 1);
      this.processRevokedBuffer(group);
    }
  }

  static processBuffer() {
    if (this.acceptsCookies) {
      while (this.setCookieBuffer.length) {
        const callback = this.setCookieBuffer.shift();
        callback();
      }
    }
    // Process each group individually, removing processed items from data source
    if (this.acceptedGroups.length > 0) {
      this.acceptedGroups.forEach((group) => {
        if (this.setGroupCookieBuffer[group]) {
          while (this.setGroupCookieBuffer[group].length) {
            const callback = this.setGroupCookieBuffer[group].shift();
            callback();
          }
        }
      });
    }
  }

  static processRevokedBuffer(group) {
    // Execute callbacks when denyGroupCookies is called
    if (this.revokedGroupBuffer[group]) {
      while (this.revokedGroupBuffer[group].length) {
        const callback = this.revokedGroupBuffer[group].shift();
        callback();
      }
    }
  }
}
